import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';
import type { ReflectionStatus } from '@lms/shared/types';

export const reflectionKeys = {
  all: ['reflections'] as const,
  lists: () => [...reflectionKeys.all, 'list'] as const,
  list: (params: Record<string, unknown>) => [...reflectionKeys.all, 'list', params] as const,
  details: () => [...reflectionKeys.all, 'detail'] as const,
  detail: (id: string) => [...reflectionKeys.details(), id] as const,
};

export function useReflections(params?: {
  materialId?: string;
  userId?: string;
  status?: ReflectionStatus;
}) {
  return useQuery({
    queryKey: reflectionKeys.list((params as Record<string, unknown>) || {}),
    queryFn: () => apiClient.reflections.list(params),
  });
}

export function useReviewReflection() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: { status: ReflectionStatus; feedback?: string; reviewedBy: string };
    }) => apiClient.reflections.review(id, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: reflectionKeys.all });
    },
  });
}
